// src/store/slices/biasesSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { BiasOption, BiasesResponse } from '../../features/template/types/index';
import TemplateApi from '../../features/template/api/templateApi';

interface BiasesState {
  senderBiases: BiasOption[];
  contentBiases: BiasOption[];
  loading: boolean;
  error: string | null;
}

const initialState: BiasesState = {
  senderBiases: [],
  contentBiases: [],
  loading: false,
  error: null,
};

export const fetchBiases = createAsyncThunk(
  'biases/fetchBiases',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Making API call to fetch biases...');
      const response = await TemplateApi.getBiases();
      console.log('Biases API response:', response);
      return response;
    } catch (error) {
      console.error('Error fetching biases:', error);
      return rejectWithValue(
        error instanceof Error 
          ? error.message 
          : 'Failed to fetch biases'
      );
    }
  }
);

const biasesSlice = createSlice({
  name: 'biases',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBiases.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBiases.fulfilled, (state, action: PayloadAction<BiasesResponse>) => {
        state.loading = false;
        state.senderBiases = action.payload.sender_biases;
        state.contentBiases = action.payload.content_biases;
      })
      .addCase(fetchBiases.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string || 'An error occurred';
      });
  },
});

export const { clearError } = biasesSlice.actions;

// Selectors
export const selectSenderBiases = (state: { biases: BiasesState }) => state.biases.senderBiases;
export const selectContentBiases = (state: { biases: BiasesState }) => state.biases.contentBiases;
export const selectBiasesLoading = (state: { biases: BiasesState }) => state.biases.loading;
export const selectBiasesError = (state: { biases: BiasesState }) => state.biases.error;

export default biasesSlice.reducer;
